const menu = document.getElementById('category-menu');
        const menuItems = document.querySelectorAll('.category-menu-items');
        const showAllBtn = document.getElementById('show-all-btn');

        let isShowingAll = false;

        // Initially hide all items except the top 9
        for (let i = 9; i < menuItems.length; i++) {
            menuItems[i].style.display = 'none';
        }

        // Add click event listener to toggle between "Show All" and "Show Less"
        showAllBtn.addEventListener('click', () => {
            if (isShowingAll) {
                // Show only the top 6 items
                for (let i = 9; i < menuItems.length; i++) {
                    menuItems[i].style.display = 'none';
                }
                showAllBtn.textContent = 'Explore More';
            } else {
                // Show all items
                for (let i = 0; i < menuItems.length; i++) {
                    menuItems[i].style.display = 'block';
                }
                showAllBtn.textContent = 'Explore Less';
            }
            isShowingAll = !isShowingAll;
        });